import React from 'react';
import Icon from '../../Icon';
import { C } from '../../../utils/styles';

export default function UploadModeCards({ onPickStandard, onPickAuto, onDownloadTemplate }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
      <button
        data-testid="upload-mode-standard"
        onClick={onPickStandard}
        style={{
          padding: 20, borderRadius: 12, border: `1px solid ${C.border}`, background: '#fff',
          textAlign: 'left', cursor: 'pointer', transition: 'all 0.15s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.borderColor = C.blue; }}
        onMouseLeave={(e) => { e.currentTarget.style.borderColor = C.border; }}
      >
        <Icon name="document-text-outline" style={{ fontSize: 22, color: C.blue, marginBottom: 8 }} />
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>Standard template</div>
        <div style={{ fontSize: 12, color: C.textMid, lineHeight: 1.5, marginBottom: 12 }}>
          Use our pre-built census template — fastest path if you can fill it in.
        </div>
        <div
          onClick={(e) => { e.stopPropagation(); onDownloadTemplate?.(); }}
          role="button"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            color: C.blue, fontSize: 12, fontWeight: 700,
          }}
        >
          <Icon name="download-outline" style={{ fontSize: 14 }} />
          Download template
        </div>
      </button>

      <button
        data-testid="upload-mode-auto"
        onClick={onPickAuto}
        style={{
          padding: 20, borderRadius: 12, border: `1px solid ${C.border}`, background: '#fff',
          textAlign: 'left', cursor: 'pointer', transition: 'all 0.15s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.borderColor = C.blue; }}
        onMouseLeave={(e) => { e.currentTarget.style.borderColor = C.border; }}
      >
        <Icon name="sparkles-outline" style={{ fontSize: 22, color: C.blue, marginBottom: 8 }} />
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>Auto-detect format</div>
        <div style={{ fontSize: 12, color: C.textMid, lineHeight: 1.5, marginBottom: 12 }}>
          Upload your payroll export — we'll figure out the format.
        </div>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          color: C.textMid, fontSize: 12, fontWeight: 600,
        }}>
          Supports: ADP, Paycom, Paycor, Gusto, more
        </div>
      </button>
    </div>
  );
}
